import './App.css';
import React, { useState, useEffect, useCallback } from "react";
import { Unity, useUnityContext } from "react-unity-webgl";
import { ethers, Signer, wait } from 'ethers'; // ethers v5
import { checkout } from '@imtbl/sdk';


function App({ passportInstance, checkoutSDK }) {



  const { unityProvider, isLoaded, loadingProgression, addEventListener, removeEventListener, sendMessage } = useUnityContext({
    loaderUrl: "Build/sw.loader.js",
    dataUrl: "Build/sw.data",
    frameworkUrl: "Build/sw.framework.js",
    codeUrl: "Build/sw.wasm",
    streamingAssetsUrl: "StreamingAssets"
  });
  // We'll use a state to store the device pixel ratio.
  const [devicePixelRatio, setDevicePixelRatio] = useState(
    window.devicePixelRatio
  );
  const ERC20_TOKEN_ADDRESS = "0x0bf52740F5BC21998b3FA8210Ebac159c5803f95"
  const PACK_CONTRACT_ADDRESS = "0xc19a52e7c9e05e1160494ce2bcb97012e5b953d4"
  const TICKET_CONTRACT_ADDRESS = "0x1b541547857864a2cec7dcc576d4e6444e1f38c6"

  const contractInstance = async (signer, contractAddress) => {

    return new ethers.Contract(
      contractAddress,
      [
        'function burn(uint256 tokenId)',
      ],
      signer,
    );
  };

  const burn = async (signer, contractAddress, tokenId) => {

    try {
      const contract = await contractInstance(signer, contractAddress);
      const transaction = await contract.burn(tokenId);
      //console.log('tr', await transaction)
      const receipt = await transaction.wait(1);
      sendMessage("GameManager", "WebGLPassportBurn", JSON.stringify({ message: 'ok' }));
    }
    catch (e) {
      sendMessage("GameManager", "WebGLPassportBurnError", e.message);
    }

  }

  const handlePackOpening = useCallback((tokenId) => {
    (async () => {
      if (isLoaded) {
        try {
          const passportProvider = passportInstance.connectEvm();
          const provider = new ethers.providers.Web3Provider(passportProvider);
          const accounts = await passportProvider.request({ method: "eth_requestAccounts" });
          const signer = provider.getSigner();
          await burn(signer, PACK_CONTRACT_ADDRESS, tokenId)
        }
        catch (e) {
          console.log('error packOpening', e)
        }
      }
    })()
  }, [isLoaded]);

  const handleBurnTicket = useCallback((tokenId) => {
    (async () => {
      if (isLoaded) {
        try {
          const passportProvider = passportInstance.connectEvm();
          const provider = new ethers.providers.Web3Provider(passportProvider);
          const accounts = await passportProvider.request({ method: "eth_requestAccounts" });
          const signer = provider.getSigner();
          await burn(signer, TICKET_CONTRACT_ADDRESS, tokenId)
        }
        catch (e) {
          console.log('error burnTicket', e)
        }
      }
    })()
  }, [isLoaded]);

  const handleAuthenticate = useCallback(async () => {
    if (isLoaded) {

      try {
        const passportProvider = passportInstance.connectEvm();
        const accounts = await passportProvider.request({ method: "eth_requestAccounts" });
        const userProfile = await passportInstance.getUserInfo();
        const accessToken = await passportInstance.getAccessToken();
        const idToken = await passportInstance.getIdToken();
        let tmp = { email: userProfile.email, accessToken: accessToken, accounts: accounts, idToken: idToken };
        console.log(JSON.stringify(tmp));
        sendMessage("GameManager", "WebGLPassportAuthenticate", JSON.stringify(tmp));
      }
      catch (e) {
        sendMessage("GameManager", "WebGLPassportError", e.message);
      }
    }
  }, [isLoaded]);

  const handleGetBalance = useCallback(async (contractAddress) => {
    if (isLoaded) {
      const passportProvider = passportInstance.connectEvm();
      const provider = new ethers.providers.Web3Provider(passportProvider);
      const accounts = await passportProvider.request({ method: "eth_requestAccounts" });
      console.log('account', accounts)
      const address = await provider.getSigner().getAddress();
      const tmp = await checkoutSDK.getBalance({ provider: provider, tokenAddress: ERC20_TOKEN_ADDRESS, walletAddress: address })
      let balance = { "balance": parseFloat(tmp.formattedBalance) }
      sendMessage("WalletManager", "SetBalance", JSON.stringify(balance));
    }
  }, [isLoaded]);


  useEffect(() => {
    addEventListener("packOpening", handlePackOpening);
    return () => {
      removeEventListener("packOpening", handlePackOpening);
    };
  }, [addEventListener, removeEventListener, handlePackOpening]);

  useEffect(() => {
    addEventListener("burnTicket", handleBurnTicket);
    return () => {
      removeEventListener("burnTicket", handleBurnTicket);
    };
  }, [addEventListener, removeEventListener, handleBurnTicket]);

  useEffect(() => {
    addEventListener("getBalance", handleGetBalance);
    return () => {
      removeEventListener("getBalance", handleGetBalance);
    };
  }, [addEventListener, removeEventListener, handleGetBalance]);


  useEffect(() => {
    addEventListener("passportLogin", handleAuthenticate);
    return () => {
      removeEventListener("passportLogin", handleAuthenticate);
    };
  }, [addEventListener, removeEventListener, handleAuthenticate]);

  useEffect(
    function () {
      // A function which will update the device pixel ratio of the Unity
      // Application to match the device pixel ratio of the browser.
      const updateDevicePixelRatio = function () {
        setDevicePixelRatio(window.devicePixelRatio);
      };
      // A media matcher which watches for changes in the device pixel ratio.
      const mediaMatcher = window.matchMedia(
        `screen and (resolution: ${devicePixelRatio}dppx)`
      );
      // Adding an event listener to the media matcher which will update the
      // device pixel ratio of the Unity Application when the device pixel
      // ratio changes.
      mediaMatcher.addEventListener("change", updateDevicePixelRatio);
      return function () {
        // Removing the event listener when the component unmounts.
        mediaMatcher.removeEventListener("change", updateDevicePixelRatio);
      };
    },
    [devicePixelRatio]
  );
  return (
    <div className="container">
      {!isLoaded && (
        <>
          <div id="loading-cover">
            <div id="unity-loading-bar">
              <div id="unity-logo"></div>
              <div id="unity-progress-bar-empty">
                <div id="unity-progress-bar-full" style={{ width: Math.round(loadingProgression * 100) + '%' }}></div>
              </div>
            </div>
          </div>
        </>
      )}
      <Unity
        unityProvider={unityProvider}
        devicePixelRatio={devicePixelRatio}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          visibility: isLoaded ? "visible" : "hidden"
        }}
      />
      {/* <button onClick={handleClickSpawnEnemies}>TEST</button> */}
    </div>
  )
}

export default App;
